import axios from 'axios';

import * as PubSub from 'pubsub-js';
import { BASE_URL, API_KEY } from '../.env';

export const REQUEST_TIMEOUT = 180000;

export const Network = axios.create({
  baseURL: BASE_URL,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
    'X-API-KEY': API_KEY
  },
  params: {},
  timeout: REQUEST_TIMEOUT
});

export const setInterceptors = (instance) => {
  instance.interceptors.request.use(
    (request) => {
      request.metadata = { startTime: Date.now() };
      return request;
    },
    (error) => {
      console.error('commons.request error', error);
      Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      const duration = Date.now() - response.config.metadata.startTime;
      console.log(
        `>> ${response.config?.method} ${response.config?.url} ${
          response.config?.params ? JSON.stringify(response.config?.params) : ''
        } in ${duration}ms\n\n`,
        response
      );
      return response;
    },
    (error) => {
      const duration = Date.now() - error.config.metadata.startTime;
      console.log(
        `>> ${error.config?.method} ${error.config?.url} ${
          error.config?.params ? JSON.stringify(error.config?.params) : ''
        } in ${duration}ms\n\n   Status ${error?.response?.status} with ${
          error?.response?.data ? JSON.stringify(error?.response?.data) : ''
        }\n\n`,
        error?.config,
        '\n',
        error?.response
      );

      if (
        error?.response?.status === 401 /* || error?.response?.status === 403 */
      ) {
        PubSub.publish('UNAUTHORIZED_ACCESS');
      } else {
        throw error;
      }
      return error;
    }
  );
};

setInterceptors(Network);

export const setAuthToken = (token) => {
  Network.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const getCSRFToken = async () => {
  const response = await Network.get('admin/csrf-token', {
    withCredentials: true
  });
  Network.defaults.headers.post['X-CSRF-Token'] = response.data.csrfToken;
};

export class ServiceError extends Error {
  constructor(source, axiosError) {
    super(
      axiosError?.response?.data?.message
        ? axiosError?.response?.data?.message
        : `${source}: ${axiosError?.message}`
    );
    this.source = source;
    this.title = axiosError?.message;
    this.axiosError = axiosError;
    this.status =
      axiosError?.response?.status || axiosError?.response?.data.httpCode || 0;
    this.data = axiosError?.response?.data;
    this.isNetworkError =
      !!axiosError?.message?.includes('Network Error') ||
      !!axiosError?.message?.includes(
        `timeout of ${REQUEST_TIMEOUT}ms exceeded`
      );
    Object.setPrototypeOf(this, ServiceError.prototype);
  }
}
